import { GatewayCreate  } from './GatewayCreate'
import { GatewayEdit } from './GatewayEdit'
import { GatewayShow } from './GatewayShow'
import { GatewayList } from './GatewayList'
export { GatewayCreate, GatewayEdit, GatewayShow, GatewayList }
